import "./RankingList.scss";

export default function RankingList() {
  return (
    <section className="sales-layout__page ranking-list">
      <h1>Hitliste</h1>
      <p>Hier wird zukünftig die Artikel-Hitliste angezeigt.</p>
    </section>
  );
}
